module.exports = __webpack_public_path__ + "static/media/mariposa-corte-01.8c1e099f.png";